import * as Yup from 'yup';

export const createWebhookSchema = Yup.object().shape({
  description: Yup.string().required('Preencha o campo nome'),
  product_id: Yup.array().of(Yup.number().integer()).min(1, 'Selecione pelo menos um produto'),
  url: Yup.string()
    .url('Insira uma URL válida, obrigatório http:// ou https://')
    .required('Preencha o campo URL, obrigatório http:// ou https://'),
  content_type: Yup.string().required('Selecione um formato da resposta')
});
